// extracted by mini-css-extract-plugin
export default {"styledLink":"StyledLink_styledLink__dVyED","fullWidth":"StyledLink_fullWidth__KqTmp"};